import React, { useContext, useEffect, useState } from "react";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";

import { Link, useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import HandleSearch from "../../../utils/CommonSearchComponent";
import moment from "moment";
import { exportJson } from "../../../utils/export";
import { JsonToExcel } from "react-json-to-excel";
import CustomLoader from "../../common/customLoader";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";
import { AvatarCell, replaceWith } from "../../../utils/Constants";
import TableContent from "../../../components/atoms/TableContent";
import media from "../../../media";
import { useDispatch,useSelector } from "react-redux";
import { fetchDeletedAuditsThunk } from "../../../store/thunks/deletedAuditsThunk";
import { Form } from "antd";

const DeletedAudits = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname.replace("/", "");
  const [tableForm] = Form.useForm();

  const { list, pageInfo, count, loading } = useSelector(
    (state) => state.qmsDeletedAudits
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: Number(process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE || 50),
  });
  const shouldShowPagination = count > pagination.pageSize;
  const tablePagination = shouldShowPagination
    ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: count,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        locale: { items_per_page: "" },
        onChange: (page, pageSize) => {
          setPagination({ current: page, pageSize });
        },
      }
    : false;
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  
  {
    /*Declaring states*/
  }
  const [showLoader, setShowLoader] = useState(true);
  const 
    [searchData, setSearchData] = useState([]),
    [selectedRowsArray, setSelectedRowsArray] = useState([]),
    [selectedRowKeys, setSelectedRowKeys] = useState([]),
    [listItems, setListItems] = useState([]),
    [allTransactionIdsArr, setAllTransactionIdsArr] = useState([]);
  const [deletedAuditLists,setDeletedAuditLists] = useState([]);

  const [selectionType, setSelectionType] = useState("checkbox");
  
  const columns = [
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditId.svg} alt="icon" />
            ID
          </div>
        );
      },
      dataIndex: "id",
      render: (text, row) => (
        <Link
          to={"/deleted-audits/" + row.id}
          state={{
            route: location.pathname,
            formMethd: row.formMethd,
          }}
          style={{ color: "black" }}
        >
          <span
            className="rowstyle bfont no-wrap"
            style={{ color: "#1875CB" }}
            onClick={handleDeleteAuditDetailClickedLink}
          >
            {text}
          </span>
        </Link>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentIcon.svg} alt="icon" />
            Form
          </div>
        );
      },
      dataIndex: "form",
      render: (text, row) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return secureLocalStorage.getItem("role") === "tl" ||
        secureLocalStorage.getItem("role") === "atl" ? (
          <span className="rowstyle no-wrap" title={text}>{truncatedText}</span>
        ) : (
          <Link
            to={"/auditForms/" + row.formId}
            state={{ route: "/auditForms" }}
            style={{ color: "black" }}
          >
            <span
              className="rowstyle bfont no-wrap"
              style={{ color: "#1875CB" }}
              onClick={() =>
                secureLocalStorage.setItem("fromComponent", "delete-audits")
              }
            title={text}>{truncatedText}</span>
          </Link>
        )      
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.reasonIcon.svg} alt="icon" />
            Reason
          </div>
        );
      },
      dataIndex: "auditDeleteReason",
      render: (text, record, index) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return <span className="rowStyle no-wrap" title={text}>{truncatedText}</span>;
      }    
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.transactionId.svg} alt="icon" />Transaction ID
          </div>
        );
      },
      dataIndex: "transaction_id",
      render: (text, record, index) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return <span className="rowStyle no-wrap" title={text}>{truncatedText}</span>;
      }
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditor.svg} alt="icon" />Auditor
          </div>
        );
      },
      dataIndex: "auditor",
      render: (auditor) => <AvatarCell avt={auditor} />,              
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.agent.svg} alt="icon" />Agent
          </div>
        );
      },
      dataIndex: "agent",
      render: (agent) => <AvatarCell avt={agent} />,      
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.supervisor.svg} alt="icon" />Supervisor
          </div>
        );
      },
      dataIndex: "supervisor",
      render: (supervisor) => <AvatarCell avt={supervisor} />,      
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentDate.svg} alt="icon" />
            Audit Date
          </div>
        );
      },
      dataIndex: "createdAt",
      render: (text) => (
        <span className="rowstyle no-wrap">
          {text && moment(text).format("ddd, DD MMM YYYY HH:mm:ss")}
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentDate.svg} alt="icon" />
            Transaction Date
          </div>
        );
      },
      dataIndex: "transaction_date",
      render: (text) => (
        <span className="rowstyle no-wrap">
          {text && moment(text).format("ddd, DD MMM YYYY")}
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentStatus.svg} alt="icon" />Status
          </div>
        );
      },
      dataIndex: "stage",
      render: (text) => (
        // <span className="rowstyle no-wrap">
        //   {" "}
        //   <img
        //     src={
        //       text === "Audit Completed"
        //         ? "audited.PNG"
        //         : text === "Audit Pending"
        //         ? "pending.png"
        //         : text === "Accepted"
        //         ? "completed.png"
        //         : "disputed.png"
        //     }
        //     style={{ width: "17px" }}
        //     alt="logo"
        //   />
        //   &nbsp;{text?.toUpperCase()}
        // </span>
        <span className="rowStyle no-wrap">
          <span
            className={`cusStatus ${
              text === "Audit Completed"
                ? "cusActive"
                : text === "Audit Pending"
                ? "cusInActive"
                : text === "Accepted"
                ? "cusActive"
                : "statusDisputed"
            }`}
          >{text}
          </span>
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditScoree.svg} alt="icon" />Score
          </div>
        );
      },
      dataIndex: "score",
      render: (text, row) => <span className="rowStyle no-wrap tableBtn bfont">{text}%</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.activeAudits.svg} alt="icon" />Active
          </div>
        );
      },
      dataIndex: "active",
      render: (text) => (
        <span
          className={
            text?.toUpperCase() === "ACTIVE"
               ? "cusStatus cusActive"
              : "cusStatus cusClosed"
          }
        >
          {text && text?.toUpperCase()}
        </span>
      ),
    },
    {
      title: () => {
        return <div className="tableTitle"> </div>;
      },
      dataIndex: "comments",      
      render: (text, record, index) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return <span className="rowStyle no-wrap" title={text}>
          {" "}
          <img
            src={text > 0 ? "comment.png" : "noComment.png"}
            style={{ width: "17px" }}
            alt="logo"
          />
          &nbsp;{truncatedText}
          </span>;
      }
    },
    {
      title: () => {
        return <div className="tableTitle"> </div>;
      },
      dataIndex: "auditor",
      render: (text) => (
        <span className="rowStyle no-wrap">
          {text && text?.profilePicUrl ? (
            <img
              className="auditProfileImage"
              src={
                process.env.REACT_APP_BACKEND + "/images/" + text?.profilePicUrl
              }
              alt={text?.name}
            />
          ) : (
            <img
              className="auditProfileImage"
              src={process.env.REACT_APP_BACKEND + "/images/dummy.jpg"}
              alt={text?.name}
            />
          )}
        </span>
      ),
    },
  ];

  {
    /*begin::Setting some localstorage values on click of Deleted Audit Id's link*/
  }
  const handleDeleteAuditDetailClickedLink = () => {
    secureLocalStorage.setItem("clickedLink", "deleteAuditsDetailLinkClick");
    secureLocalStorage.setItem("fromComponent", "deleted-audits");
  };
  {
    /*end::Setting some localstorage values on click of Deleted Audit Id's link*/
  }
  {
    /*begin::Fetching all list of Deleted Audits*/
  }

  {
    /*begin::Fetching all list of Deleted Audits*/
  }
  //setSelectedRowKeys([]);
  // Fetch Deleted Audit List
  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);
        const allKeys = Object.keys(localStorage);
        let removeItems;
        switch (secureLocalStorage.getItem("fromComponent")) {
          case "deleted-audits": {
            removeItems = [
              "@secure.n.totalAuditedCount",
              "@secure.s.auditScore",
              "@secure.j.parameterSelectedList",
              "@secure.j.auditFormInput",
              "@secure.s.auditFormCall",
              "@secure.n.auditedQuestionScoreCount",
              "@secure.n.auditedQuestionCount",
              "@secure.j.countMap",
              "@secure.s.clickedLink",
              "@secure.j.timeStampsDetails",
              "@secure.n.weightageFlag",
              "@secure.j.updatedQMF",
              "@secure.s.savedAuditId",
              "@secure.b.auditedFormSubmit",
              "@secure.s.aID",
              "@secure.j.savePayloadRequestParams",
            ];
            break;
          }
          default: {
            break;
          }
        }
        allKeys &&
          allKeys.forEach((key) => {
            if (removeItems && removeItems.includes(key)) {
              localStorage.removeItem(key);
            }
          });
        
        const hasSearchedValue = secureLocalStorage.getItem("hasSearchedValue")
          ? "yes"
          : "";
        const searchKeyword = secureLocalStorage.getItem("searchKeyword") || "";

        const res = await dispatch(
          fetchDeletedAuditsThunk({
            searchData: searchData,
            setSearchData: setSearchData,
            selectedRowsArray: selectedRowsArray,
            setSelectedRowsArray: setSelectedRowsArray,
            
            searchIn: currentPath,
            callActionFrom: currentPath,
            hasSearchedValue,
            searchKeyword,
            route: currentPath,
            pagination: {
              current: pagination.current,
              page: pagination.current,
              pageSize: pagination.pageSize,
            },
            allTransactionIdsArr: allTransactionIdsArr,
            setAllTransactionIdsArr: setAllTransactionIdsArr,
          })
        ).unwrap();
        if (res?.meta?.deletedAuditLists) {
          setDeletedAuditLists(res?.meta?.deletedAuditLists);
        }
      } catch (err) {
        console.error("Error fetching deleted audits:", err);
      } finally {
        setShowLoader(false);
      }
    };

    fetchData();
  }, [currentPath, pagination.current, pagination.pageSize, dispatch]);

  {
    /*end::Fetching all list of Deleted Audits*/
  }

  {
    /*Export functionality on Audit Listing's table clicking on checkboxes*/
  }

        const exportColumns = [
        { key: "Auditor", path: "auditor.name" },
        { key: "Audit Score", path: "score" },
        { key: "Client", path: "client.name" },
        { key: "Department", path: "department.name" },
        { key: "Process", path: "process.name" },
        { key: "Audit Form", path: "auditForm.formName" },
        { key: "Audit Form Type", path: "hasWeightage" },
        { key: "Transaction ID", path: "transaction_id" },
        {
          key: "Transaction Date",
          path: "transactionDate",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD") : "",
        },
        {
          key: "Reason for Audit's delete",
          path: "auditDeleteReason",
        },

        { key: "Reason for Audit's back date", path: "auditBackDateReason" },
        {
          key: "Reason for duplicate Transaction ID",
          path: "transactionDuplicateReason",
        },

        { key: "Transaction Amount", path: "transactionAmount" },
        { key: "Invoice count", path: "invoiceCount" },
        { key: "Insured Name", path: "insuredName" },
        { key: "Supervisor", path: "agentReportingSupervisor.name" },
        { key: "Status", path: "stage" },
        { key: "Agent Name", path: "agent.name" },
        { key: "Agent Emp ID", path: "agent.empID" },
        {
          key: "Maximum Possible Score",
          path: "auditedScoreInfo",
          formatter: (value) =>
            value ? JSON.parse(value).auditedMaxQuestionCount : "",
        },
        {
          key: "Actual Score",
          path: "auditedScoreInfo",
          formatter: (value) =>
            value ? JSON.parse(value).auditedQuestionCount : "",
        },
        {
          key: "Fatal",
          path: "fatalNotFatalInfo",
          formatter: (value) => (value ? JSON.parse(value).fatal : ""),
        },
        {
          key: "Not Fatal",
          path: "fatalNotFatalInfo",
          formatter: (value) => (value ? JSON.parse(value).notFatal : ""),
        },
        {
          key: "Created At",
          path: "createdAt",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
        },
        {
          key: "Updated At",
          path: "updatedAt",
          formatter: (value) =>
            value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
        },
      ];

  const rowSelection = {
    type: "checkbox",
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      exportJson(
        selectedRows,
        deletedAuditLists,
        "DeletedAuditReport",
        exportColumns,
        setGlobalState,
        globalState
      );
    },
  };
  
  return (
    <div className="all-content">
      <CustomLoader showLoader={showLoader} />
      <TopContainerHeader
        sectionTitle="Deleted Audits"
        sectionDescription={
          showLoader
            ? "Loading..."
            : `${count || 0} Found`
        }
        hasSectionButton={true}
        sectionButtons={[
          {
            isVisible:
              (secureLocalStorage.getItem("role") === "admin" ||
                secureLocalStorage.getItem("role") === "qc") &&
              globalState.selectedRowKeysChildInfo?.length > 0,
            itemType: "downloadAsExcel",
            itemClassName: "",
            itemName: "",
            renderComponent: (
              <JsonToExcel
                title="Download as Excel"
                data={globalState.exportDeletedAuditReportJson}
                fileName="deletedAuditReport"
                btnClassName="defaultBtn defaultGreyBtn"
              />
            ),
          },
        ]}
        hasFilter={false}
        buttonTitle="Add New"
      />

      <div className="all-table-holder">
        <Form form={tableForm} component={false}>
          <TableContent
            rowSelection={rowSelection}
            rowClassName={(record, index) =>
              record.auditBackDateReason ? "auditBackDateReasonRow" : ""
            }
            bordered={false}
            columns={columns}
            dataSource={list}
            pagination={tablePagination}          
          />
        </Form>
      </div>
    </div>
  );
};

export default DeletedAudits;
